import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AbstractImageIdentifierRegistry } from "abweb/service/image/api/AbstractImageIdentifierRegistry";
import { ImageIdentifierInfo } from "abweb/service/image/api/ImageIdentifierInfo";
import { ImagePhysicalScale } from "abweb/service/image/api/ImagePhysicalScale";
import { ImageType } from "abweb/service/image/api/ImageType";
import AbSDKImageInfoJsonText from "abweb/service/image/AbSDKImageInfo.json?text";
import AbSDKImageFamiliesJsonText from "abweb/service/image/AbSDKImageFamilies.json?text";
const AbSDKImageInfoJson = JSON.parse(AbSDKImageInfoJsonText);
const AbSDKImageFamiliesJson = JSON.parse(AbSDKImageFamiliesJsonText);

// The valid values for the types below are in AbSdkImageSchema.json and in ImageSearch.tsx

export class AbSDKImageIdentifierRegistry extends AbstractImageIdentifierRegistry {
  static convertAbSDKImageInfo2ImageIdentifierInfo(value) {
    let x = new ImageIdentifierInfo("absdk", value.key, ImageType.SVG, [new ImagePhysicalScale(value.fileName, NaN, NaN)]);
    // Point the extra back at me
    x.extra = value;
    return x;
  }
  static initialize() {
    if (AbSDKImageIdentifierRegistry.abSDKImageInfo === null) {
      AbSDKImageIdentifierRegistry.abSDKImageInfo = AbSDKImageInfoJson;
    }
    if (AbSDKImageIdentifierRegistry.abSDKImageFamilies === null) {
      AbSDKImageIdentifierRegistry.abSDKImageFamilies = AbSDKImageFamiliesJson;
    }
  }
  createImageIdentifierInfos() {
    AbSDKImageIdentifierRegistry.initialize();
    return AbSDKImageIdentifierRegistry.abSDKImageInfo.map(AbSDKImageIdentifierRegistry.convertAbSDKImageInfo2ImageIdentifierInfo.bind(AbSDKImageIdentifierRegistry));
  }
}
_defineProperty(AbSDKImageIdentifierRegistry, "abSDKImageInfo", null);
_defineProperty(AbSDKImageIdentifierRegistry, "abSDKImageFamilies", null);
//# sourceMappingURL=AbSDKImageInfo.js.map
